export const mediaImageCmsHelperText = 'Image content to be used throughout the Coa app.';
